var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PaymentInfo',{attrs:{"receiverAddress":_vm.receiverAddress}}),_c('div',{staticClass:"back-btn",on:{"click":function($event){return _vm.back()}}},[_vm._v("\n    Back\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }